// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    configUpdated: false,
    apiUrl:'/api/v1/',
    configurationUrl:':/api/v1/config/',
    chatServiceConfigurationUrl:':/api/v1/config/getchatserviceurl',
    logoLight: './assets/images/logos/bilgebot-logo.png',
    logoDark: './assets/images/logos/bilgebot-dark-logo.png',
    loginPage: '/login',
    logoutPage: '/logout',
    primaryColor: "rgb(6, 118, 154)",
    primaryColorDim: "rgb(6, 118, 154, 0.15)",
    secondaryColor: "rgb(195, 208, 70)",
    secondaryColorDim: "rgb(195, 208, 70, 0.15)",
    tertiaryColor: "rgb(195, 208, 70)",
    organisationId: -1,
    chatApiUrl: 'https://chat-service-test.bilgebot.ai/',
}
